import { render, staticRenderFns } from "./WhIcon.vue?vue&type=template&id=be867782&scoped=true"
import script from "./WhIcon.vue?vue&type=script&lang=js"
export * from "./WhIcon.vue?vue&type=script&lang=js"
import style0 from "./WhIcon.vue?vue&type=style&index=0&id=be867782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be867782",
  null
  
)

export default component.exports